const { default: api } = require("config/axios");

export const certifiedByList = () => api.get("/certified-by");
